export const defaultCell = {
  occupied: false,
  ghost: false,
};
